import { createTheme, responsiveFontSizes, adaptV4Theme } from '@mui/material/styles';

import palette from './palette';
import typography from './typographyAdmin';
import overrides from './overrides';

// Create theme using new API
let theme = createTheme(adaptV4Theme({
  palette,
  typography,
  components: overrides // ✅ replaced "overrides" with "components" in MUI v5
}));

// Make font sizes responsive
theme = responsiveFontSizes(theme);

export default theme;
